import { lazy, Suspense } from "react";

import type { ActiveEnforcementShaderVariant } from "./ActiveEnforcementShader";
import { StaticShaderFallback } from "./ActiveEnforcementBanner";

const ActiveEnforcementShader = lazy(() =>
  import("./ActiveEnforcementShader").then((module) => ({
    default: module.ActiveEnforcementShader,
  })),
);

type SwipeToUnlockTrackShaderProps = {
  variant: Extract<ActiveEnforcementShaderVariant, "enforcement" | "pause">;
  animate: boolean;
};

/**
 * Shader background for the wide swipe-to-unlock pill.
 *
 * Uses the same ActiveEnforcementShader as ActiveEnforcementBanner (default
 * camera). The pill's ~7:1 aspect ratio exposes empty space on the right
 * because the plane is framed for taller containers — solved here with a
 * CSS overscan wrapper (scale + left-biased origin) clipped by the parent.
 */
export function SwipeToUnlockTrackShader({ variant, animate }: SwipeToUnlockTrackShaderProps) {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden rounded-[inherit]">
      <div
        className="absolute inset-0 origin-[18%_50%] scale-[1.38]"
        aria-hidden
      >
        <Suspense fallback={<StaticShaderFallback variant={variant} />}>
          <ActiveEnforcementShader animate={animate} variant={variant} />
        </Suspense>
      </div>
    </div>
  );
}
